"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteSalesforceUserCredentials = exports.GetSalesForceAuthenticationStatus = exports.SetModelThreshold = exports.GetTrainingResults = exports.GetPredictDefName = exports.DeployModel = exports.GetJobResult = exports.GetJobStatus = exports.StartJob = exports.SayHello = void 0;
var tag_typescript_client_1 = require("@tableau/tag-typescript-client");
var Cookies = require("js-cookie");
var tagAPI = function () {
    var token = Cookies.get('XSRF-TOKEN') || '';
    var headers = {
        'X-XSRF-TOKEN': token,
    };
    var configuration = new tag_typescript_client_1.Configuration({
        // Unfortunately, the generated library defaults to sending the request to http://localhost,
        // instead of a relative path.  To work around this, we override the base path.
        // Since the default is used if basePath is falsy, we can't use the empty string.
        // Hence the use of a single space.
        basePath: ' ',
        headers: headers,
    });
    return new tag_typescript_client_1.DefaultApi(configuration);
};
var SayHello = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, tagAPI().predictiveModelControllerServiceSayHello({
                    tableauPredictivemodelcontrollerV1SayHelloRequest: request,
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.SayHello = SayHello;
var StartJob = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, tagAPI().predictiveModelControllerServiceStartTransferAndTrain({
                    tableauPredictivemodelcontrollerV1StartTransferAndTrainRequest: request,
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.StartJob = StartJob;
var GetJobStatus = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, tagAPI().predictiveModelControllerServiceGetTransferAndTrainStatus(request)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.GetJobStatus = GetJobStatus;
var GetJobResult = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, tagAPI().predictiveModelControllerServiceGetJobResult(request)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.GetJobResult = GetJobResult;
var DeployModel = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, tagAPI().predictiveModelControllerServiceDeployModel({
                    tableauPredictivemodelcontrollerV1DeployModelRequest: request,
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.DeployModel = DeployModel;
var GetPredictDefName = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, tagAPI().predictiveModelControllerServiceGetPredictDefName(request)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.GetPredictDefName = GetPredictDefName;
var GetTrainingResults = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, tagAPI().predictiveModelControllerServiceGetTrainingResults(request)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.GetTrainingResults = GetTrainingResults;
var SetModelThreshold = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, tagAPI().predictiveModelControllerServiceSetModelThreshold({
                    tableauPredictivemodelcontrollerV1SetModelThresholdRequest: request,
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.SetModelThreshold = SetModelThreshold;
var GetSalesForceAuthenticationStatus = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, tagAPI().predictiveModelControllerServiceGetSalesforceAuthStatus(request)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.GetSalesForceAuthenticationStatus = GetSalesForceAuthenticationStatus;
var DeleteSalesforceUserCredentials = function (request) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, tagAPI().predictiveModelControllerServiceDeleteSalesforceUserCredentials(request)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.DeleteSalesforceUserCredentials = DeleteSalesforceUserCredentials;
//# sourceMappingURL=TagHelpers.js.map